import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Heart, ShoppingCart } from 'lucide-react';
import { Button } from '../components/ui/button';
import ProductCard from '../components/ProductCard';
import axios from 'axios';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Wishlist() {
  const [products, setProducts] = useState([]);
  const [wishlistIds, setWishlistIds] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const fetchWishlist = async () => {
    try {
      const { data } = await axios.get(`${API}/wishlist`, { withCredentials: true });
      setProducts(data.products || []);
      setWishlistIds(data.product_ids || []);
    } catch {} finally { setLoading(false); }
  };

  useEffect(() => { fetchWishlist(); }, []);

  const toggleWishlist = async (productId) => {
    try {
      await axios.post(`${API}/wishlist/toggle`, { product_id: productId }, { withCredentials: true });
      setProducts(prev => prev.filter(p => p.id !== productId));
      setWishlistIds(prev => prev.filter(id => id !== productId));
      toast.success('Removed from wishlist');
    } catch { toast.error('Failed'); }
  };

  const addToCart = async (productId) => {
    try {
      await axios.post(`${API}/cart/add`, { product_id: productId, quantity: 1 }, { withCredentials: true });
      toast.success('Added to cart');
    } catch { toast.error('Failed to add to cart'); }
  };

  if (loading) return <div className="min-h-screen flex items-center justify-center bg-cream"><div className="spinner"></div></div>;

  return (
    <div className="min-h-screen bg-cream" data-testid="wishlist-page">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-8">
        <h1 className="font-heading text-3xl font-bold text-dark-brown mb-8">My Wishlist</h1>

        {products.length === 0 ? (
          <div className="text-center py-20">
            <Heart className="w-16 h-16 text-border-custom mx-auto mb-4" />
            <p className="font-body text-lg text-light-brown mb-4">Your wishlist is empty</p>
            <Button onClick={() => navigate('/products')} className="bg-rust hover:bg-rust/90 text-cream font-body rounded-full px-8">
              Browse Products
            </Button>
          </div>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6" data-testid="wishlist-grid">
            {products.map(p => (
              <ProductCard key={p.id} product={p} onAddToCart={addToCart} onToggleWishlist={toggleWishlist} isWishlisted={true} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
